import Header from '../Components/Header'
import Footer from '../Components/Footer'
import HeroSection from '../Components/HeroSection'
import AboutEvent from '../Components/AboutEvent'
import InauguralSection from '../Components/InauguralSection'
import TechShowcase from '../Components/TechShowcase'
import ImpactShowcase from '../Components/ImpactShowcase'
import ValedictorySession from '../Components/ValedictorySession'
import AwardsAnnouncements from '../Components/AwardsAnnouncements'
import PartnershipAwards from '../Components/PartnershipAwards'
import Agenda from '../Components/Agenda'
import EvaluationCriteria from '../Components/EvaluationCriteria'
import FAQSection from '../Components/FAQSection'
import FeaturedSpeakers from '../Components/FeaturedSpeakers'
import GlimpsesVideo from '../Components/GlimpsesVideo'
import WhySummit from '../Components/WhySummit'
import SocialImpactAwards from '../Components/SocialImpactAwards'
import EventImages from '../Components/EventImages'

function Home() {
  return (
    <>
      <Header/>
      <HeroSection/>
      <AboutEvent/>
      <InauguralSection/>
      <TechShowcase/>
      <ImpactShowcase/>
      <ValedictorySession/>
      <PartnershipAwards/>
      <AwardsAnnouncements/>
      <EventImages/>

      <Footer/>
    </>
  )
}

export default Home
